<template>
  <div>
    <el-input-number
      :key="inputKey"
      v-model="showValue"
      :size="size"
      :precision="precision"
      :step="stepValue"
      @change="changeHanlder"
    ></el-input-number>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityQuantityInputBox",
  props: {
    value: {
      type: [Number, String],
      default: "0",
    },
    min: {
      type: [String, Number],
      default: 0.0,
    },
    max: {
      type: [String, Number],
      default: 10000000.0,
    },
    size: {
      type: String,
      default: "small",
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(val) {
        this.showValue = val;
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      immediate: true,
    },
    min: {
      handler(newVal, oldVal) {},
      immediate: true,
    },
  },
  data() {
    return {
      inputKey: "",
      showValue: null,
      precision: 3,
      minValue: 0,
      stepValue: 1,
    };
  },
  destroyed() {},

  mounted() {
    this.getTenantQuantityDigit();
    this.inputKey = Math.random();
  },

  methods: {
    getTenantQuantityDigit() {
      let tenantSimplifiedPojo = this.$storageUtil.getTenantSimplifiedPojo();
      this.precision = Number(tenantSimplifiedPojo.commodityQuantityDigit || 0);
      if (typeof this.min === "undefined") {
        this.minValue = this.$jsTool.getTenantDecimalLength();
      } else {
        this.minValue = this.min;
      }
      this.changeHanlder(this.value);
    },
    changeHanlder(value) {
      let res = value;
      if (value == null || value == "") {
        res = this.allowEmpty
          ? null
          : Number(this.minValue).toFixed(this.decimalLength);
      }
      if (res) {
        res = Number(value).toFixed(this.decimalLength);
        if (Number(res) < Number(this.minValue)) {
          this.$message.error("输入的数量不得小于" + this.minValue);
          res = Number(this.minValue).toFixed(this.decimalLength);
        } else if (this.max && Number(res) > Number(this.max)) {
          this.$message.error("输入的数量不得大于" + this.max);
          res = Number(this.max).toFixed(this.decimalLength);
        }
      }
      this.showValue = res;
      res = Number(res);
      this.$emit("input", res);
      this.$emit("change", res);
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/fm/CommodityQuantityInputBox.vue